import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/LandingPage/Footer/Footer';

export default function CookiesPolicy() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-b from-black via-[#0A192F] to-[#060D1B] text-white">
      <div className="container mx-auto px-6 py-24 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-12 mt-10">
          {t('cookies.title')}
        </h1>

        <div className="space-y-10 text-gray-300 text-lg leading-relaxed">
          {['what', 'types', 'why', 'control', 'tools', 'contact'].map((key) => (
            <section key={key}>
              <h2 className="text-2xl font-bold text-white mb-2">{t(`cookies.${key}Title`)}</h2>
              <p dangerouslySetInnerHTML={{ __html: t(`cookies.${key}`) }} />
            </section>
          ))}
        </div>
      </div>

      <Footer />
    </main>
  );
}
